module.exports = __webpack_public_path__ + "static/media/URO_logo.dd503237.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Logos/URO_logo.png
// module id = 1836
// module chunks = 0